<template>
  <div class="boxs">
    <div class="item" @click="dialogVisible = true; getMapList()">地图编辑</div>
    <template>
      <el-dialog class="editUp" :append-to-body="true" center :visible.sync="dialogVisible" @close="onColose" width="30%">
        <div slot="title" class="title">
          <span>地图编辑</span><span></span>
        </div>
        <!-- <div class="label">
                  <span>指示器：</span> <el-radio v-model="radio" label="1">显示</el-radio>
                  <el-radio v-model="radio" label="2">不显示</el-radio>
                </div> -->
        <div class="contents">
          <el-table :data="tableData" style="width: 100%" :header-cell-style="$store.state.headerRowStyle"
            :cell-style="$store.state.cellStyle">
            <el-table-column label="地理名称" prop="addressName">
            </el-table-column>

            <el-table-column label="操作" width="60">
              <template slot-scope="scope">
                <el-popconfirm title="该地区确定删除吗？" @confirm="del(scope.row,scope.$index)">
                  <div slot="reference"><i class="el-icon-delete"></i></div>
                </el-popconfirm>
              </template>

            </el-table-column>
          </el-table>
          <div class="addAddres" @click="addAddres">
            <i class="el-icon-plus avatar-uploader-icon">添加地区</i>
          </div>
        </div>

      </el-dialog>
    </template>
    <el-dialog title="地区添加" :append-to-body="true" :visible.sync="addVisible" width="300px">
      <el-select v-model="cityName" multiple placeholder="请选择" style="width: 100%;">
        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="onAdd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import UploadImg from "./uploadImg.vue"
import { addClassicCaseAddress, getClassicCaseAddressList, delAddress } from "@/api/case.js"
import cityName from "../components/map.json"
import { getMapFeatureName, getLocalizedMapName } from "@/utils/mapLocale";
export default {
  components: {
    UploadImg
  },
  props: ['list', 'index'],

  data() {
    return {
      dialogVisible: false,
      addVisible: false,
      tableData: [],
      options: [],
      cityName: ""
    }
  },
  mounted() {


  },
  methods: {
    getMapList() {
      getClassicCaseAddressList({ isRelease: this.$store.state.editStatus }).then(res => {
        this.tableData = res.data.map((item) => ({
          ...item,
          rawAddressName: item.addressName,
          addressName: getLocalizedMapName(cityName, item.addressName, this.$store.state.language)
        }));
      })
    },
    onColose() {
      this.$emit('onClose', this.tableData.map((item) => ({
        ...item,
        addressName: item.rawAddressName || item.addressName
      })))
    },


    addAddres() {
      this.cityName = "";
      this.options = [],
        cityName.features.forEach(e => {
          let status = true;
          this.tableData.forEach(obj => {
            if (obj.name == e.properties.name || obj.rawAddressName == e.properties.name || obj.addressName == e.properties.name) {
              status = false;
            }
          })
          if (status) {
            this.options.push({
              label: getMapFeatureName(e, this.$store.state.language),
              value: e.properties.name
            })
          }

        })
      console.log('ds', this.options)
      this.addVisible = true;
    },

    del(e,i) {
      if (e.id) {
        delAddress({ id: e.id }).then(res => {
          this.$message.success('删除成功')
          this.tableData.splice(i, 1)
        })
      }

    },
    onAdd() {
      let params = []
      this.cityName.forEach(e => {
        params.push({
          addressName: e,
          "isRelease": 0,
        })
      })
      addClassicCaseAddress(params).then(res => {
        this.getMapList();
        this.addVisible = false;
      })



    }
  }
}
</script>
        
<style lang="scss" scoped>
.boxs {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  text-align: left;

  &:hover {
    border: 1px dashed #ccc;
  }

  .item {
    padding: 5px 10px;
    background: #007ffe;
    font-style: normal;
    align-items: center;
    display: none;

    cursor: pointer;
    color: #fff;

    &:first-child {
      border-bottom-right-radius: 4px;
    }
  }

  &:hover {
    .item {
      display: inline-flex;
      font-size: 14px;
    }
  }
}

::v-deep .editUp {
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #333;

    span {
      &:nth-child(2) {
        font-size: 12px;
        color: #999;
      }
    }
  }

  .contents {
    margin-top: 20px;
    max-height: 500px;
    overflow: hidden;
    overflow-y: auto;

    .img {
      width: 100px;
      height: 50px;
    }

    .label {
      font-size: 15px;
      color: #333;

      i {
        color: #007ffe;
        margin-right: 4px;
      }
    }

    .labelName {
      font-size: 14px;
      margin: 20px 0;
      height: 40px;

      .el-input__inner {
        height: 40px;
      }
    }

    .tree {
      max-height: 300px;
      margin-top: 20px;
      overflow: hidden;
      overflow-y: auto;

      .custom-tree-node {
        width: 100%;

        .row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          padding: 0 10px;
          box-sizing: border-box;

          .operate {
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .labelName {
            color: #007ffe;
          }

          .icons {
            font-size: 18px;
          }
        }
      }
    }
  }

  .dialog-foote {
    text-align: center;
    display: flex;
    justify-content: center;
  }
}

.addAddres {
  border: 1px dashed #ddd;
  padding: 10px;
  margin-top: 20px;
  text-align: center;
  cursor: pointer;
}
</style>
